import { DESKTOP_PROPERTIES } from '../../Common/DesktopProperties/desktopProperties.constants'

//Performs selector on desktopProperties state from root
export const getFromDesktopProperties = selector => ({ desktopProperties: { desktopProperties } }, ...args) =>
  selector(desktopProperties, ...args)

export const getWillDisplayContactInUserTimezone = ({ data }) =>
  data[DESKTOP_PROPERTIES.WILL_DISPLAY_CONTACT_IN_USER_TIMEZONE] === '1'

export const getUserTimezone = (_, { authenticatedUser: { user } }) =>
  user && user.timezoneString ? user.timezoneString : false
